import { render, staticRenderFns } from "./dataConnection.vue?vue&type=template&id=2d035ee0&"
import script from "./dataConnection.vue?vue&type=script&lang=js&"
export * from "./dataConnection.vue?vue&type=script&lang=js&"
import style0 from "./dataConnection.vue?vue&type=style&index=0&id=2d035ee0&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports